import { render, staticRenderFns } from "./InventoryItemMaster.vue?vue&type=template&id=dbc0d4fe&"
import script from "./InventoryItemMaster.vue?vue&type=script&lang=js&"
export * from "./InventoryItemMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports